

export const LANGUAGES = [
    { id: 'en', name: "English" },
    { id: 'ru', name: "Rusish" },
    { id: 'uk', name: "Ukrainian" },
    { id: 'pl', name: "Polish" },
    { id: 'de', name: "German" },

]